export default "__VITE_PUBLIC_ASSET__366730bb__"